<template>
<main id="content">
    <cq-breadcrumbs :history="pathHistory"></cq-breadcrumbs>
    <div class="row">
        <div class="col s12 ">
            <div class="card-panel">
                <div class="row">
                    <form
                        class="col s12"
                        @submit.prevent="saveUser"
                    >
                        <div class="row">
                            <div class="input-field col s6">
                                <input
                                    id="name"
                                    type="text"
                                    v-model.trim="name"
                                    @blur="$v.name.$touch()"
                                    :class="classValidName"
                                >
                                    <label for="name">Nombre Completo</label>
                                    <span
                                        class="helper-text"
                                        data-error="Por favor ingrese el nombre"
                                        data-success="Listo"
                                    ></span>
                            </div>
                            <div class="input-field col s6">
                                <input
                                    id="email"
                                    type="email"
                                    @blur="$v.emailValue.$touch()"
                                    v-model.trim="emailValue"
                                    :class="classValidMail"
                                >
                                    <label for="email">Correo</label>
                                    <span
                                        class="helper-text"
                                        data-error="Por favor ingrese un correo valido"
                                        data-success="Listo"
                                    ></span>
                            </div>

                        </div>
                         <div class="row">
                            <div class="input-field col s6">
                                <h6>Permisos</h6>
                            </div>
                         </div>
                        <div class="row">
                            <div class="input-field col s6">
                                Tableros

                                <hr>
                                <p>
                                  <label>
                                    <input type="checkbox" v-model="permisos['tablero-comercial']"/>
                                    <span>Tablero Comercial</span>
                                  </label>
                                </p>
                                <p>
                                  <label>
                                    <input type="checkbox" v-model="permisos['tablero-operaciones']"/>
                                    <span>Tablero Operaciones</span>
                                  </label>
                                </p>
                                <p>
                                  <label>
                                    <input type="checkbox" v-model="permisos['tablero-mantenimiento']"/>
                                    <span>Tablero Mantenimiento</span>
                                  </label>
                                </p>
                            </div>
                            <div class="input-field col s6">
                              Reportes Directivos
                                <hr>
                                <p>
                                  <label>
                                    <input type="checkbox" v-model="permisos['rd-ocupacion-tiempo']"/>
                                    <span>RD Ocupacion en tiempo</span>
                                  </label>
                                </p>
                                <p>
                                  <label>
                                    <input type="checkbox" v-model="permisos['rd-cobranza-mes']"/>
                                    <span>RD Cobranza por mes
                                    </span>
                                  </label>
                                </p>
                                <p>
                                  <label>
                                    <input type="checkbox" v-model="permisos['rd-ocupacion-financiera']"/>
                                    <span>RD Ocupacion Financiera</span>
                                  </label>
                                </p>
                                <p>
                                  <label>
                                    <input type="checkbox" v-model="permisos['rd-ocupacion-familia']"/>
                                    <span>RD Ocupación por familia</span>
                                  </label>
                                </p>

                            </div>
                        </div>
                         <div class="row">
                            <div class="input-field col s12">
                              Administración
                                <hr>
                                <p>
                                  <label>
                                    <input type="checkbox" v-model="permisos['metas']"/>
                                    <span>Metas</span>
                                  </label>
                                </p>
                                <p>
                                  <label>
                                    <input type="checkbox" v-model="permisos['usuarios']"/>
                                    <span>Usuarios</span>
                                  </label>
                                </p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col s12">
                                <button
                                    v-if="!result"
                                    type="submit"
                                    class="btn right"
                                    :class="{disabled:$v.$invalid}"
                                >Guardar</button>
                                    <button
                                        v-if="result"
                                        @click="clearForm"
                                        type="button"
                                        class="btn right"
                                    >Nuevo</button>
                            </div>
                            <div class="col s12">
                                <cq-card-message
                                    :clear-method="clearForm"
                                    :msg="resultMessage"
                                    :success="result"
                                >

                                    </cq-card-message>
                            </div>
                        </div>
                        </form>
                </div>
            </div>
        </div>

    </div>
    <div class="row">
        <div class="col l12">
            <br><br><br><br><br><br><br><br><br>
        </div>
    </div>

</main>
</template>

<script>
import Breadcrumbs from '../../components/commun/Breadcrumbs.vue';
import CardMessage from '../../components/commun/CardMessage.vue';
import { required, email } from 'vuelidate/lib/validators';
import { db, auth, secondApp } from '../../main';

export default {
  created() {
    if (this.$route.params.id) {
      this.pathHistory.splice(-1, 1);
      this.pathHistory.push({
        route: `/users/${this.$route.params.id}`,
        name: this.$route.params.name,
      });
      db
        .ref('users')
        .child(this.$route.params.id)
        .once('value', (usersnapShot) => {
          console.log(usersnapShot.val());
          this.emailValue = usersnapShot.val().email;
          this.name = usersnapShot.val().name;
          this.permisos = usersnapShot.val().permisos;
        });
    }
  },
  mounted() {},
  data() {
    return {
      /** * path to print breadcrumbs */
      pathHistory: [
        {
          route: '/',
          name: 'Inicio',
        },
        {
          route: '/users',
          name: 'Usuarios',
        },
        {
          route: '/users/add',
          name: 'Añadir Usuario',
        },
      ],
      permisosAutocomplete: null,
      name: '',
      emailValue: '',
      resultMessage: '',
      result: false,
      permisos: {
        'tablero-comercial': false,
        'tablero-operaciones': false,
        'tablero-mantenimiento': false,
        metas: false,
        usuarios: false,
        'rd-ocupacion-tiempo': false,
        'rd-cobranza-mes': false,
        'rd-ocupacion-familia': false,
        'rd-ocupacion-financiera': false,
      },
    };
  },
  validations: {
    name: {
      required,
    },
    emailValue: {
      required,
      email,
    },
  },
  components: {
    cqBreadcrumbs: Breadcrumbs,
    cqCardMessage: CardMessage,
  },
  methods: {
    saveUser() {
      const vueInstance = this;
      if (this.$route.params.id) {
        db
          .ref('users')
          .child(this.$route.params.id)
          .set({
            name: vueInstance.name,
            email: vueInstance.emailValue,
            permisos: vueInstance.permisos,
          })
          .then(() => {
            M.toast({ html: 'User saved succesfully' });
          });
      } else {
        secondApp
          .auth()
          .createUserWithEmailAndPassword(this.emailValue, 'password').then((userCredential) => {
            secondApp.auth().sendPasswordResetEmail(userCredential.user.email);
            db
              .ref('users').child(userCredential.user.uid)
              .set({
                name: vueInstance.name,
                email: vueInstance.emailValue,
                permisos: vueInstance.permisos,
              })
              .then(() => {
                M.toast({ html: 'Usuario creado con exito' });
              });
          })
          .catch((error) => {
            M.toast({ html: 'Ocurrio un error' });
            console.log(error);
          });
      }
    },
    clearForm() {
      this.name = '';
      this.emailValue = '';
      this.$v.name.$reset();
      this.$v.emailValue.$reset();
      this.result = false;
      this.resultMessage = '';
    },
  },
  computed: {
    // props to print green or red colors on text and border depending on the validation result
    classValidName() {
      return {
        invalid: this.$v.name.$error,
        valid: !this.$v.name.$error && this.$v.name.$dirty,
      };
    },
    classValidMail() {
      return {
        invalid: this.$v.emailValue.$error,
        valid: !this.$v.emailValue.$error && this.$v.emailValue.$dirty,
      };
    },
  },
};
</script>

<style scoped>
.card-panel {
  margin: 16px;
}
</style>
